// EXT ABR 23/03/2020
export class AddressClassModel {
    AddressType: number;
    AddressSource: string;
    Country: string;
    City: string;
    Canton: string;
    District: string;
    Street: string;
    Company: string;
    IsPrimary: number;
    Action: string;
    SpecificAddress: string;
    RefRecId: number;
    LinkSite: string;
    AddressId: string;
    CustAccount: string;
    ProjectId: string;
    UserId: number;
    AllowConfigAddress: boolean;

    constructor() {
        this.AddressType = 0;
        this.AddressSource = '';
        this.Country = '';
        this.City = '';
        this.Canton = '';
        this.District = '';
        this.Street = '';
        this.Company = '';
        this.IsPrimary = 0;
        this.Action = '';
        this.SpecificAddress = '';
        this.RefRecId = 0;
        this.LinkSite = '';
        this.AddressId = '';
        this.CustAccount = '';
        this.ProjectId = '';
        this.UserId = 0;
        this.AllowConfigAddress = false;
    }
  }
  // EXT ABR 23/03/2020
